import './instrument';
import './utils/stale-chunk-reload';
import type { InvoiceImportResult } from '@cpce/shared';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './api/queries.utils';
import { ErrorPage } from './components/ErrorPage';
import { AuthProvider, useAuth } from './context/useAuth.tsx';
import './index.css';
import { Toaster } from 'react-hot-toast';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultNotFoundComponent: () => (
    <ErrorPage title="Page introuvable" message="Cette page n'existe pas ou a été déplacée." />
  ),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  // A document dropped on « Nouvel achat » that turns out to be an avoir, or the reverse, is
  // handed to the other page rather than uploaded again.
  interface HistoryState {
    invoiceImport?: InvoiceImportResult;
  }
}

function RouterProviderWithContext() {
  const auth = useAuth();

  return <RouterProvider router={router} context={{ auth }} />;
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Une erreur est survenue.</p>}>
      <QueryClientProvider client={queryClient}>
        <Toaster position="top-center" />
        <AuthProvider>
          <RouterProviderWithContext />
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
